import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { SuccessApiResponse } from 'src/app/framework/crosscutting/http-service/success-api-response';
import Swal from 'sweetalert2';
import { PromotionsService } from '../../promotions.service';
import { CurrencyPipe,formatDate } from "@angular/common";
import { S } from '@angular/cdk/keycodes';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';


@Component({
  selector: 'app-promo-code-history',
  templateUrl: './promo-code-history.component.html',
  styleUrls: ['./promo-code-history.component.scss'] ,
  providers: [CurrencyPipe],
})
export class PromoCodeHistoryComponent extends FeaturesBaseComponent implements OnInit {
  rowSelection: string;
  searchValue;
  showEditPromotion: boolean = false;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  promoCodeHistoryData: any = [];
  promoCodeHistoryColumnDef: any = [];
  columnDefs: any;
  isButtonDisabled:boolean
  constructor(private router: Router, private promotionService: PromotionsService ,private currencyPipe: CurrencyPipe,private adminViewServices:AdminViewService) {
    super();
    this.getPromoCodeHistory();
  }
  getPromoCodeHistory() {
    this.promotionService.getPromoCodesHistory().subscribe(res => {
      this.promoCodeHistoryData = res['data']
      this.promoCodeHistoryData.forEach(x => {
        x.promocodeStartDateTime=moment(x.promocodeStartDateTime).format('MM/DD/YYYY');
        x.validityOfPromo= moment(x.promocodeStartDateTime).format('MM/DD/YYYY') + ' '+'to' +' '+ moment(x.promocodeEndDateTime).format('MM/DD/YYYY');
        if(x.notificationSentDttm){
          x.sent='Yes'
        }else{
          x.sent='No'
        }
        });
      this.gridApi.refreshCells();

    })
  }

  ngOnInit(): void {

    this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

    super.ngOnInit();
    const self = this;
    this.promoCodeHistoryColumnDef = [
      { field: 'promocodeNumber', headerName: 'Promo Code' },
      { field: 'discountValueType', headerName: 'Promo Code Value',hide:true, width: 230,cellRenderer: function (data) {
          
          if (data.value == '$') {
                //return this.currencyPipe.transform(parseFloat(data.data.purchaseDiscount));
                return '$' + parseFloat(data.data.discountValue);
            }
            if (data.value == '%') {
              return data.data.discountValue + '%'; //data.purchaseDiscount + '%';
            }
          } 
       },
      { field: 'redeemLimit', headerName: 'Redeem Limit', width: 160 ,hide:true},
      { field: 'description', headerName: 'Description', width: 160 },
      { field: 'codeGroup', headerName: 'Code Group', width: 180 },
      { field: 'carrier', headerName: 'Carrier', width: 140 },
      {
        field: 'promocodeStartDateTime', headerName: 'Promo code generated date', width: 290
      },
      {
        field: 'promoCodeSentDate', headerName: 'Promo code sent date', width: 250, cellRenderer: function (params) {
          
          if (params.data.notificationStatus) {
              if(params.data.notificationStatus.trim() == 'No') {
                return '<span class="send-action cur-point text-center rounded-pill bg-main px-3 py-1">Send</span>';
              }
              else if(params.data.notificationStatus.trim() == 'Yes') {
                return '<span class="send-action cur-point text-center border-bottom">' + moment(params.data.notificationSentDttm).format('MM/DD/YYYY') + '</span>';
              }
          } 
          // else if (params.data.notificationStatus) {
          //     if(params.data.notificationStatus.trim() == 'Yes') {
          //         console.log(params.data.notificationSentDttm)
          //       return '<span class="send-action cur-point text-center border-bottom">' + moment(params.data.notificationSentDttm).format('MM/DD/YYYY') + '</span>';
          //     }
          // }
           else {
            return '<span >-</span>';
          }

        }, onCellClicked: function (params) {
          self.sendPromoCode(params.data);

        },
      },
      {
        field: 'promocodeEndDateTime', headerName: 'Validity', width: 160, cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY')
        }
      },
      {
        field: 'validityOfPromo', headerName: 'Validity(Start and End Date)', width: 320,hide:true, cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY')
        }
      },
      { field: 'currentUsage', headerName: 'No. of Times Redeemed', width: 230 },
      { field: 'sent', headerName: 'Sent', width: 130,hide:true },
      { field: 'country', headerName: 'Country', width: 160 }
    ]
  }
  exportData() {
    let header = this.promoCodeHistoryColumnDef.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Promocode-History.csv",
      columnKeys: ["promocodeNumber","discountValueType","redeemLimit","description","codeGroup","carrier","country","promocodeStartDateTime","validityOfPromo","sent","currentUsage"]
      };
 
    params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }
      else if(cellParams && cellParams.column.colId === 'promocodeStartDateTime') {
        return moment(cellParams.value).format('MM/DD/YYYY'); //apply your timestamp formatter 
      }
      else if(cellParams && cellParams.column.colId === 'discountValueType') {
       
        if (cellParams.node.data.discountValueType == '$') {
            return this.currencyPipe.transform(cellParams.node.data.discountValue);
        }
        if (cellParams.node.data.discountValueType == '%') {
          return cellParams.node.data.discountValue + '%'; 
        }
      }
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  editPromotions() {

  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  //setTimeout(()=>{params.api.sizeColumnsToFit()}, 50);
  sendPromoCode(promoDetail) {
    

    let _promocodeId = promoDetail.promocodeId;

    if (promoDetail.notificationStatus.trim() == 'No') {
      this.promotionService.sendNotification(_promocodeId).subscribe(
        res => {
          if (res['httpcode'] == 200) {
            Swal.fire({
              title: 'Success',
              text: 'Notification sent',
              icon: 'success',
              timer: 2000
            })
            this.getPromoCodeHistory();
          }
        }
      )
      return
    }
    if (promoDetail.notificationStatus.trim() == 'Yes') {
      this.router.navigate([`features/promotions/manage-promo/received-promo/${_promocodeId}`])
      return
    }
  }

  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }

  occasionRewardsColumnDef: any = [
    { field: "date", headerName: "Date" },
    { field: "festival", headerName: "Festival " },
    { field: "country", headerName: "Country" },
    { field: "validity", headerName: "Validity" },
    { field: "status", headerName: "Status" },
  ];
 


}
